export default {
  configList: [],
  checkGIBSellerInfoData: null,
  needsPasswordChange: false,
  toasterData: {
    type: "",
    title: "",
    description: "",
  },
  hasImageError: false,
};
